export default "__VITE_ASSET__TvxAbxOb__"